import { ReactElement } from "react";
import Layout from "../../../components/layout";
import ShopBrands from "../../../components/Shops/Brands/index";

const ShopBrandPage = (): ReactElement => {
  return (
    <Layout>
      <ShopBrands />
    </Layout>
  );
};

export default ShopBrandPage;
